import { render, staticRenderFns } from "./mProveReport.vue?vue&type=template&id=3faff4a4&class=p-1&"
import script from "./mProveReport.vue?vue&type=script&lang=js&"
export * from "./mProveReport.vue?vue&type=script&lang=js&"
import style0 from "./mProveReport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/mProveReport.vue
// module id = null
// module chunks = 